import { TFunction } from 'i18next';
import { resolveLocalizedText } from './resolveLocalizedText';

export function resolveTableAttributeText(
	label: string,
	t: TFunction,
	currentLanguage: string
): string {
	const attributeKey = `table_attributes.${label}`;
	const translated = t(attributeKey);

	if (translated !== attributeKey) {
		return translated;
	}

	return resolveLocalizedText(label, currentLanguage);
}
